import { Modal } from 'antd'

export const STAGE_CONFLICT_CODE = 'STAGE_CONFLICT'

export type StageConflictErrorItem = {
  code?: string
  detail?: string
  message?: string
}

export function getStageCodeFromFormStages(stages?: {
  current?: number
  items?: Record<number, { code?: string }> | Array<{ code?: string }>
}): string | undefined {
  if (!stages || stages.current === undefined || stages.current === null) {
    return undefined
  }
  const items = stages.items
  if (!items) {
    return undefined
  }
  const item = Array.isArray(items) ? items[stages.current] : items[stages.current]
  return item?.code
}

export function extractStageConflictDetail(errors: unknown): string | null {
  if (!Array.isArray(errors)) {
    return null
  }
  for (const err of errors) {
    if (err && typeof err === 'object' && err.code === STAGE_CONFLICT_CODE) {
      return err.detail || err.message || 'Стадия карточки уже изменена. Обновите страницу.'
    }
  }
  return null
}

export function isStageConflictResponse(response: Record<string, any> | null | undefined): boolean {
  if (!response) {
    return false
  }
  if (response.error?.statusCode === 409) {
    return true
  }
  return Boolean(extractStageConflictDetail(response.errors))
}

/**
 * Показать конфликт стадии и опционально перезагрузить карточку.
 * @returns true если это был STAGE_CONFLICT
 */
export function handleStageConflictResponse(
  response: Record<string, any> | null | undefined,
  onRefresh?: () => void | Promise<void>,
): boolean {
  if (!isStageConflictResponse(response)) {
    return false
  }
  const detail =
    extractStageConflictDetail(response?.errors) ||
    response?.error?.message ||
    'Стадия карточки уже изменена. Обновите страницу.'

  Modal.warning({
    title: 'Стадия изменена',
    content: detail,
    onOk: () => {
      if (onRefresh) {
        void onRefresh()
      }
    },
  })

  if (onRefresh) {
    void onRefresh()
  }
  return true
}
